import React from 'react';
import CookiesPolicyLayout from './cookies-policy-layout';

export default class CookiesPolicy extends React.Component<{}, {}> {
    render(){
        return(
            <CookiesPolicyLayout/>
        )
    }
}